module.exports = __webpack_public_path__ + "static/media/tip_text_dog_tick_en.0ad63c79.svg";